module.exports = __webpack_public_path__ + "web_static/img/smartliving_lightoff_1015.6a06c904.png";